import React, { Component } from "react";
import okButtonIcon from "../../../../assets/images/okbutton_icon.png";
import { shuffle, sum, isEqual, filter } from "lodash";

//-----------------------------------------------------------------------------
// Multiple True Question Type - MTR
//-----------------------------------------------------------------------------
class MTRTypeQuestion extends Component {
  constructor() {
    super();
    this.state = {
      generatedAnswers: [],
      selectedCheckboxes: [],
    };
  }

  componentDidMount() {
    const { currentQuestion } = this.props;
    this.generateAnswersSet(
      currentQuestion.AData,
      currentQuestion.IsRandomAnswers,
      currentQuestion.QTypeShort,
      currentQuestion.ADataRandomLines
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.currentQuestion !== nextProps.currentQuestion) {
      this.generateAnswersSet(
        nextProps.currentQuestion.AData,
        nextProps.currentQuestion.IsRandomAnswers,
        nextProps.currentQuestion.QTypeShort,
        nextProps.currentQuestion.ADataRandomLines
      );
    }
  }

  generateAnswersSet = (
    answerData,
    isRandomAnswers,
    questionType,
    randomLinesCount
  ) => {
    let selectedCheckboxes = [];
    let generatedAnswersArray = [];

    generatedAnswersArray = filter(answerData.split("\n")).map(
      (item, index) => {
        let splittedArray = item.split("|");
        return splittedArray[0] !== ""
          ? {
              id: index + 1,
              answerValue: splittedArray[0],
              answerText: splittedArray[1],
            }
          : null;
      }
    );

    generatedAnswersArray = this.props.getRandomAnswers(
      filter(generatedAnswersArray),
      randomLinesCount
    );

    if (isRandomAnswers === "1") {
      generatedAnswersArray = shuffle(generatedAnswersArray);
    }

    generatedAnswersArray.forEach((element) => {
      selectedCheckboxes.push({
        id: element.id,
        checkedValue: 0,
      });
    });

    this.setState({
      generatedAnswers: generatedAnswersArray,
      selectedCheckboxes: selectedCheckboxes,
    });
  };

  onClickMTRAnswerCheckbox = (answer) => {
    let { selectedCheckboxes } = this.state;
    selectedCheckboxes.forEach((item) => {
      if (item.id === answer.id) {
        item.checkedValue = item.checkedValue === 1 ? 0 : 1;
      }
    });
    this.setState({
      selectedCheckboxes,
    });
  };

  onClickVerifyMTRAnswer = () => {
    let { selectedCheckboxes, generatedAnswers } = this.state;
    let { currentQuestion, currentQuestionId } = this.props;
    let generatedAnswersValues = generatedAnswers.map((item) =>
      item.answerValue === "T" ? 1 : 0
    );
    let resultArray = selectedCheckboxes.map((element, index) =>
      element.checkedValue === generatedAnswersValues[index] ? 1 : 0
    );
    let questionDetails = {
      number: currentQuestionId,
      questionText: currentQuestion.QLong,
      QTypeShort: currentQuestion.QTypeShort,
      questionGraphicUrl: currentQuestion.QGraphicURL,
      expectedAnswersCount: resultArray.length,
      correctAnswersCount: sum(resultArray),
    };
    questionDetails.isCorrect = isEqual(
      questionDetails.expectedAnswersCount,
      questionDetails.correctAnswersCount
    )
      ? 1
      : 0;
    this.props.addAttendedQuestion(questionDetails);
  };

  render() {
    const { generatedAnswers, selectedCheckboxes } = this.state;
    return (
      <div className="answer-options-container">
        {generatedAnswers.map((item, itemIndex) => {
          return (
            <div
              className={"single-answer-block"}
              key={"answer_" + itemIndex}
              onClick={() => {
                this.onClickMTRAnswerCheckbox(item);
              }}
            >
              {selectedCheckboxes.length > 0 && (
                <i
                  className={
                    "checkbox-icon fa " +
                    (selectedCheckboxes[itemIndex].checkedValue === 1
                      ? "fa-check-square-o"
                      : "fa-square-o")
                  }
                  aria-hidden="true"
                ></i>
              )}
              {item.answerText}
            </div>
          );
        })}
        <div className="submit-btn-container">
          <div className="submit-btn" onClick={this.onClickVerifyMTRAnswer}>
            <div className="submit-btn-icon">
              <img src={okButtonIcon} alt="ok-icon" />
            </div>
            <div className="submit-btn-text">Submit</div>
          </div>
        </div>
      </div>
    );
  }
}

export default MTRTypeQuestion;
